<div class="w-full flex flex-col gap-4 p-4" [formGroup]="form">
    <app-page-header
        [urlName]="'Contador'"
        urlPath="contador"
    ></app-page-header>

    <p-card class="md:max-w-250">
        <div class="w-full flex flex-col gap-4">
            <h1 class="text-2xl font-bold">Editar/Incluir Contador</h1>

            <div class="w-full grid sm:grid-cols-12 grid-cols-1 gap-4 items-end">
                <app-input-cpf-cnpj
                    label="CPF ou CNPJ"
                    formControlName="CPF_CNPJ"
                    [row]="true"
                    class="sm:col-span-4"
                ></app-input-cpf-cnpj>

                <app-input
                    id="nome"
                    label="Nome"
                    formControlName="NOME"
                    class="sm:col-span-8"
                ></app-input>

                <app-input
                    id="email"
                    label="Email"
                    formControlName="EMAIL"
                    class="sm:col-span-4"
                ></app-input>

                <app-input-telefone
                    label="Telefone"
                    formControlName="FONE"
                    class="sm:col-span-4"
                ></app-input-telefone>

                <app-input
                    id="crc"
                    label="CRC"
                    formControlName="CRC"
                    class="sm:col-span-4"
                ></app-input>

                <app-input-cep
                    label="CEP"
                    formControlName="CEP"
                    (onBlur)="verificaCepValido($event)"
                    class="sm:col-span-4"
                ></app-input-cep>

                <app-input
                    id="endereco"
                    label="Endereço"
                    formControlName="ENDERECO"
                    class="sm:col-span-8"
                ></app-input>

                <app-input
                    id="bairro"
                    label="Bairro"
                    formControlName="BAIRRO"
                    class="sm:col-span-4"
                ></app-input>

                <app-input
                    id="complemento"
                    label="Complemento"
                    formControlName="COMPLEMENTO"
                    class="sm:col-span-8"
                ></app-input>

                <app-input
                    id="uf"
                    label="UF"
                    formControlName="UF"
                    class="sm:col-span-4"
                ></app-input>

                <app-input
                    id="cidade"
                    label="Cidade"
                    formControlName="CIDADE"
                    class="sm:col-span-4"
                ></app-input>

                <app-input
                    id="numero"
                    label="Número"
                    formControlName="NUMERO"
                    class="sm:col-span-4"
                ></app-input>
            </div>

            <div
                class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
            >
                <app-button
                    variant="danger"
                    (click)="cancelar()"
                    class="md:max-w-45 w-full"
                    >Cancelar</app-button
                >

                <app-button
                    variant="success"
                    (click)="processarFormulario()"
                    class="md:max-w-45 w-full"
                    >Salvar</app-button
                >
            </div>
        </div>
    </p-card>
</div>
